export default __webpack_public_path__ + "fonts/example-img1.svg";